import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slider from 'rc-slider'
import { change } from 'redux-form';

import { convert } from '../../../helpers/currencyConvertion';

import rcSliderStyles from 'rc-slider/assets/index.css';
import withStyles from 'isomorphic-style-loader/withStyles';

class PriceRange extends Component {
    static propTypes = {
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        from: PropTypes.string.isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        change: PropTypes.any.isRequired,
        handleSubmit: PropTypes.any,
        step: PropTypes.number,
        onRangeChange: PropTypes.func
    };

    static defaultProps = {
        min: 0,
        max: 0,
        step: 100
    };

    constructor(props) {
        super(props);
        this.state = {
            minPrice: 0,
            maxPrice: 0
        };
    }

    componentDidMount() {
        const { minPrice, maxPrice } = this.props;
        this.setState({
            minPrice,
            maxPrice
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { minPrice, maxPrice } = nextProps;
        this.setState({
            minPrice,
            maxPrice
        });
    }

    updateValue = async (sliderState) => {
        const { change, min, max, onRangeChange } = this.props;
        if (sliderState && sliderState.length) {
            this.setState({
                minPrice: sliderState[0],
                maxPrice: sliderState[1]
            });
            if (onRangeChange) {
                onRangeChange([sliderState[0], sliderState[1]]);
            }
            if (sliderState[0] == min && sliderState[1] == max) {
                await change('SearchForm', 'priceRangeLabel', [min, max]);
            } else {
                await change('SearchForm', 'priceRangeLabel', sliderState);
            }
        }
    }

    onChangeComplete = async (sliderState) => {
        const { change, from, base, rates, handleSubmit, min, max } = this.props;
        let minPrice, maxPrice;
        let values = sliderState;

        if (sliderState) {
            this.setState({
                minPrice: sliderState[0],
                maxPrice: sliderState[1]
            });
        }

        if (rates != null && rates != undefined) {
            minPrice = convert(base, rates, sliderState[0], from);
            maxPrice = convert(base, rates, sliderState[1], from);
            values = [minPrice, maxPrice];
        }
        if (sliderState[0] == min && sliderState[1] == max) {
            await change('SearchForm', 'priceRange', null);
        } else {
            await change('SearchForm', 'priceRange', values);
        }
        await change('SearchForm', 'priceRangeLabel', sliderState);
        await change('SearchForm', 'currentPage', 1);
    }

    render() {
        const { min, max, step } = this.props;
        const { minPrice, maxPrice } = this.state;

        return (
            <div>
                <Slider
                    range
                    min={min}
                    max={max}
                    defaultValue={[min, max]}
                    value={[minPrice, maxPrice]}
                    onChange={this.updateValue}
                    onChangeComplete={this.onChangeComplete}
                    allowCross={true}
                    step={step}
                />
            </div>
        );
    }
}

const mapState = (state) => ({
    base: state.currency.base,
    rates: state.currency.rates
});

const mapDispatch = {
    change
};

export default withStyles(rcSliderStyles)(connect(mapState, mapDispatch)(PriceRange));